export const APP_VERSION = '1.0.0';
export const BUILD_NUMBER = 20200704;

export const BASE_URL = 'https://getdiskon.com/';
export const API_BASE_URL = window.location.host === 'getdiskon.com' ? 'https://api.getdiskon.com/' : 'https://staging.api.gdbusiness.id/';

export const MOMENT_READABLE_DATETIME_FORMAT = 'D MMM YYYY, HH:mm';
export const MOMENT_READABLE_DATE_FORMAT = 'D MMM YYYY';
export const MOMENT_SQL_DATE_FORMAT = 'YYYY-MM-DD';
export const MOMENT_SQL_TIME_FORMAT = 'HH:mm:ss';
export const MOMENT_SQL_TIME_FORMAT_MINUTE = 'HH:mm';
export const MOMENT_SQL_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';